import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { axiosInstances, config } from "config";
import * as React from "react";
import { useQuery } from "react-query";

function useSetupAuth0() {
  const [authReady, setAuthReady] = React.useState(false);
  const { getAccessTokenSilently, logout } = useAuth0();
  const queryResult = useQuery(["auth0Token"], () => getAccessTokenSilently(), {
    staleTime: 5 * 60 * 1000, // 5 minutes - token is fresh for this duration
    cacheTime: 10 * 60 * 1000, // 10 minutes - keep in cache after becoming stale
    refetchOnWindowFocus: false, // Don't refetch on window focus
    refetchOnMount: false, // Don't refetch on component remount
    refetchOnReconnect: false, // Don't refetch on reconnect
    retry: 3, // Retry failed token fetches 3 times
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff: 1s, 2s, 4s, max 30s
    onError: () => {
      // Only logout after all retries are exhausted
      const logoutUrl = config.auth0LogoutUrl || window.location.origin;
      logout({ returnTo: logoutUrl });
    },
  });
  const { data } = queryResult;

  // Set Authentication header with auth0 token
  React.useEffect(() => {
    if (data) {
      // Setup global audio instance
      const { defaults: globalDefaults } = axios;
      const { headers: globalHeaders } = globalDefaults;
      globalDefaults.headers = {
        ...globalHeaders,
        Authorization: `Bearer ${data}`,
      };

      Object.values(axiosInstances).forEach((instance) => {
        const { defaults } = instance;
        const { headers } = defaults;
        defaults.headers = { ...headers, Authorization: `Bearer ${data}` };
      });
      setAuthReady(true);
    }
  }, [data]);

  return authReady;
}

export { useSetupAuth0 };
